import { render, staticRenderFns } from "./MegaMenuSide.vue?vue&type=template&id=a61f8fcc&"
import script from "./MegaMenuSide.vue?vue&type=script&lang=js&"
export * from "./MegaMenuSide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports